module.exports = "<div class=\"container-fluid\">\n    <app-header></app-header>\n    <app-body></app-body>\n    <app-footer></app-footer>\n</div>"